import React, { useEffect, useState } from "react";
import "./styles.scss";
import "./mobile.scss";
import { FormHeader, OfferCardSmall } from "../../../components";
import Slider from "react-slick";
import { getTopOffers } from "../../console/services/offer.service";

const Index = (props) => {
  const [topPicksOffers, setTopPicksOffers] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const fetchOffers = async (count) => {
    try {
      setIsLoading(true);
      if (count) {
        let result = await getTopOffers(count);
        console.log("getTopOffers::", result);
        if (result?.data?.data?.length > 0) {
          setTopPicksOffers(result?.data?.data);
          setIsLoading(false);
        } else {
          setTopPicksOffers([]);
          setIsLoading(false);
        }
      }
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  const settings = {
    variableWidth: true,
    className: "slider variable-width",
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 2, //number of items sliding at a time
    initialSlide: 0,
    cssEase: "cubic-bezier(0.33, 1, 0.68, 1)",
    // afterChange: (index) => setCurrentSlide(index),
    // nextArrow: (
    //   <div className="rvow__next">
    //     <Button
    //       data={{
    //         buttonIcon: true,
    //         btnIcon: <FiChevronRight />,
    //         buttonType: isLastSlide ? "disabled" : "icon",
    //         buttonSize: "md",
    //         style: "rvow__next",
    //       }}
    //     />
    //   </div>
    // ),

    // prevArrow: (
    //   <div className="rvow__prev">
    //     <Button
    //       data={{
    //         buttonIcon: true,
    //         btnIcon: <FiChevronLeft />,
    //         buttonType: isFirstSlide ? "disabled" : "icon",
    //         buttonSize: "md",
    //         style: "rvow__prev",
    //       }}
    //     />
    //   </div>
    // ),
  };

  useEffect(() => {
    if (topPicksOffers.length > 0) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % topPicksOffers.length);
      }, 6500);
      return () => clearInterval(interval);
    }
  }, [topPicksOffers]);

  useEffect(() => {
    const fetchData = async () => {
      fetchOffers(props.count);
    };
    if (props.active && props.count) {
      fetchData();
    }
  }, [props.active && props.count]);

  return (
    <>
      {(topPicksOffers?.length > 0 || isLoading) && (
        <div className="news-offers-wrapper">
          <div className={"now-header"}>
            <FormHeader
              data={{
                formHeader: "Top Picks for You",
                size: "view-header",
              }}
            />
          </div>

          <div className={"now-offer-card-wrap"}>
            <Slider
              {...settings}
              className={"rvow__slider d-flex flex-row justify-content-center"}
            >
              {(topPicksOffers || []).map((item, index) => (
                <div className="d-flex pt-2 mr-2 mb-3">
                  <OfferCardSmall
                    key={item.offerId}
                    id={`${item.offerId}`}
                    animate={"animate__fadeIn"}
                    isFavorites={false}
                    isLoading={isLoading}
                    data={item}
                    size={"lg"}
                    type={"master"}
                    onClick={async () => {
                      const generatedSlug = item?.merchant?.merchantName
                        ?.replace(/[\u200B-\u200D\uFEFF]/g, "")
                        ?.replace(/\//g, "")
                        ?.replace(/\s*-\s*/g, " ")
                        ?.trim()
                        .split(/\s+/)
                        .slice(0, 5)
                        .join("-")
                        .replace(/-+/g, "-");
                      window.open(
                        `https://creditcardoffers.lk/${generatedSlug}/${item.category?.categoryName}/${item.bank?.bankName}/${item.offerId}`
                      );
                      // this.props.onClickViewMoreOfferDetails(
                      //   item,
                      //   item?.category,
                      //   item?.bank
                      // );

                      //========= createNewImpression =========
                      // const position = await getGeoLocation();
                      // console.debug("position", position);
                      // const { latitude, longitude } =
                      //   position?.coords;
                      // const insight = await getInsight();
                      // const [location, ip] = await Promise.all([
                      //   getLocationName(latitude, longitude),
                      //   getIPAddress(),
                      // ]);
                      // let state = newsUserDetails();
                      // console.debug("Insight:", insight);
                      // let impressionRes = await createNewImpression({
                      //   merchantId: item?.merchantId,
                      //   offerId: item?.offerId,
                      //   categoryId: item?.categoryId,
                      //   bankId: item?.bankId,
                      //   latitude: position?.coords?.latitude,
                      //   longitude: position?.coords?.longitude,
                      //   location: location,
                      //   ip: ip,
                      //   user: state?.userId,
                      //   insightId: insight?.insightId,
                      // });
                      // console.info("impression_res", impressionRes);
                      ///==================================================
                    }}
                  />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      )}
    </>
  );
};

export default Index;
